var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"no_style",attrs:{"href":_vm.link}},[_c('vx-card',{staticClass:"overflow-hidden small-card mb-5"},[_c('div',{attrs:{"slot":"no-body"},slot:"no-body"},[_c('div',{staticClass:"p-4",class:'flex justify-between flex-row-reverse items-center'},[_c('feather-icon',{staticClass:"p-2 inline-flex rounded-full",class:'status--' +
              _vm.title
                .toString()
                .toLowerCase()
                .replace(' ', '_')
                .replace('.', ''),attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"truncate"},[_c('h3',{staticClass:"mb-1 font-bold"},[_vm._v(_vm._s(_vm.count))]),_c('span',[_vm._v(_vm._s(_vm.title.replace("_", " ")))])])],1)])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }